// extracted by mini-css-extract-plugin
export default {"type":"FileBrowserRow-type-WduSE TableRowCell-cell-giPrj"};